// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pubBiz/TabBar/index.less
// module id = 687
// module chunks = 418